import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/nfse/cartaCorrecao/';

class CartaCorrecaoService {
    constructor() {
        this.idCliente = null;
        this.idContribuinte = null;
        this.idUsuario = null;
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    save(cartaCorrecao) {
        this.idUsuario = LoginService.currentUserValue.usuario.idUsuario;
        return axios.post(API_URL + 'create?idUsuario=' + this.idUsuario, JSON.stringify(cartaCorrecao),
        {headers: this.headers});
    }

    buscarCartasNfse(id){
        return axios.get(API_URL + 'buscarCartasNfse?id=' + id,
        {headers: this.headers});
    }

    podeEmitirCarta(id, idCliente){
        return axios.get(API_URL + 'podeEmitirCarta?id=' + id+'&idCliente='+idCliente,
        {headers: this.headers});
    }

    cancelar(id, idCliente) {
        return axios.post(API_URL + 'cancelar?id=' + id+'&idCliente='+idCliente, null,
        {headers: this.headers});
    }

    consultaCartaCorrecao(cartaId){
        return axios.post(API_URL + 'consultaCartaCorrecao?id=' + cartaId, null,
            {headers: this.headers});
    }

    consultaCartaCorrecaoForaDoPrazo(id){
        return axios.post(API_URL + 'consultaCartaCorrecaoForaDoPrazo?id=' + id, null,
            {headers: this.headers});
    }


}

export default new CartaCorrecaoService();